import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputMask from "react-input-mask";

import StringUtil from "../../actions/string.js";
import UI from "../../actions/ui-helper";
import API from "../../actions/api-helper";
import DataUtil from "../../actions/data.js";
import ConsultaLancamentoResultado from "./ConsultaLancamentoResultado.js";

class ConsultaLancamento extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      consulta: this.getInitialState(),
      resultado: [],
      pronto: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = UI.handleChange.bind(this);
  }
  
  getInitialState() {
    return {
      dataInicial: DataUtil.primeiroDiaMes(),
      dataFinal: DataUtil.ultimoDiaMes(),
      categoriaId: 0,
      envolvido: "",
      descricao: "",
      valorInicial: "0.00",
      valorFinal: "999999.99",
      periodicidade: "TODAS",
      situacao: 0
    };
  }

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.inputHelpers();
    UI.dataTable(this.tableId);
  }

  componentDidMount() {
    UI.inputHelpers();

    UI.loader("show", "Buscando categorias...");
    API.get("/financeiro/categorias")
    .then((json) => {
      let pronto = json.data.length > 0;
      if (!pronto) {
        UI.alert(true, "Nenhuma categoria financeira cadastrada.", "info");
      }
      else {
        this.setState({ categorias: json.data, pronto: pronto });
      }
      UI.loader("hide");
    })
    .catch((json) => {
      UI.alert(false, json.message);
      UI.loader("hide");
    })
  }

  handleSubmit(event) {
    event.preventDefault();

    UI.loader("show", "Um momento...");
    API.get("/financeiro/lancamentos/consulta?" + StringUtil.serialize(this.state.consulta))
    .then((json) => {
      this.setState({ resultado: json.data });
      UI.loader("hide");
    })
    .catch((json) => {
      UI.alert(false, json.message);
      UI.loader("hide");
    });
  }

  render() {
    if (!this.state.pronto) return false;
    this.tableId = StringUtil.uuid(5);
    return (
      <form
      className="form-sample"
      autoComplete="off"
      spellCheck="false"
      onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="form-group row">      
                    <div className="col-md-6">
                      <h4 className="card-title">CONSULTA DE LANÇAMENTOS</h4>
                    </div>
                    <div className="col-md-6 text-right">
                      <button
                        onClick={() => { this.props.history.push("/financeiro/lancamento/cadastro"); }}
                        className="btn btn-rounded btn-icons btn-outline-success"
                        type="button">
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                <div className="form-group row">
                    <div className="col-md-2">
                      <label>Data Inicial</label>
                      <InputMask
                        placeholder="DATA"
                        name="consulta.dataInicial"
                        className="form-control"
                        mask="99/99/9999"
                        value={this.state.consulta.dataInicial}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-2">
                      <label>Data Final</label>
                      <InputMask
                        placeholder="DATA"
                        name="consulta.dataFinal"
                        className="form-control"
                        mask="99/99/9999"
                        value={this.state.consulta.dataFinal}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label>Categoria</label>
                      <select
                        name="consulta.categoriaId"
                        className="form-control"
                        value={this.state.consulta.categoriaId}
                        onChange={this.handleChange}
                      >
                        <option value={0}>TODAS</option>
                        {this.state.categorias.map((cat, i) => {
                          return (
                            <option key={i} value={cat.id}>{cat.nome}</option>
                          );  
                        })}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label>Valor Inicial (R$)</label>
                      <input
                        type="number"
                        step="any"
                        name="lancamento.valorInicial"
                        value={this.state.consulta.valorInicial}
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-2">
                      <label>Valor Final (R$)</label>
                      <input
                        type="number"
                        step="any"
                        name="lancamento.valorFinal"
                        value={this.state.consulta.valorFinal}
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                <div className="form-group row">
                    <div className="col-md-4">
                      <label>Descrição</label>
                      <input
                        placeholder="DESCRIÇÃO DO LANÇAMENTO"
                        autoFocus
                        name="consulta.descricao"
                        type="text"
                        className="form-control"
                        value={this.state.consulta.descricao}
                        onChange={this.handleChange}
                      />
                    </div>
                    
                    <div className="col-md-3">
                      <label>Pagador/Beneficiário</label>
                      <input
                        placeholder="NOME DO ENVOLVIDO"
                        autoFocus
                        name="consulta.envolvido"
                        type="text"
                        className="form-control"
                        value={this.state.consulta.envolvido}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-2">
                      <label>Situação</label>
                      <select
                        name="consulta.situacao"
                        className="form-control"
                        value={this.state.consulta.situacao}
                        onChange={this.handleChange}
                      >
                        <option value={0}>TODOS</option>
                        <option value={1}>QUITADOS</option>
                        <option value={2}>ABERTOS</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label>Periodicidade</label>
                      <select
                        disabled
                        name="consulta.periodicidade"
                        className="form-control"
                        value={this.state.consulta.periodicidade}
                        onChange={this.handleChange}
                      >
                        <option value="TODAS">TODAS</option>
                        <option value="A_VISTA">À VISTA</option>
                      </select>
                    </div>
                  </div>
                <div className="row">
                  <div className="col-sm-12 text-right">
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary mb-2"
                    >
                      <i className="fa fa-search"></i>&nbsp;
                        Pesquisar
                    </button>
                  </div>
                </div>
                <ConsultaLancamentoResultado resultado={this.state.resultado} />
              </div>
            </div>
          </div>
        </div>
      </form >
    );
  }
}

export default withRouter(ConsultaLancamento);
